//import $ from 'jquery';
import { current } from "@reduxjs/toolkit";
import * as appConstants from "../overrides/appconstants";
export function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function deleteCookie() {
  let key = "authKey";
  if (document.cookie) {
    document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    return true;
  }
  return false;
}
export const getUrlParameter = (name) => {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  let regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  let results = regex.exec(window.location.search);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
};

export function formatDate(date) {
  var d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();
  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return [year, month, day].join("-");
}

export function addDays(date, days) {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result.toISOString().slice(0, 10);
}

export function subtractDate(fromDate, toDate) {
  const from = new Date(fromDate);
  const to = new Date(toDate);
  const diffTime = to - from;
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
}

export function subtractYears(date, years) {
  var subtractedDate = new Date();
  subtractedDate.setFullYear(date.getFullYear() - years);
  return formatDate(subtractedDate);
}

export function calculateAge(dateOfBirth) {
  var dob = new Date(dateOfBirth);

  //calculate month difference from current date in time
  var month_diff = Date.now() - dob.getTime();

  //convert the calculated difference in date format
  var age_dt = new Date(month_diff);

  //extract year from date
  var year = age_dt.getUTCFullYear();

  //now calculate the age of the user
  var age = Math.abs(year - 1970);

  //display the calculated age
  return age;
}

export function calculateAgeInMonths(dob, startDate) {
  // const currentYear = new Date();
  const dateOfBirth = new Date(dob.replace(/-/g, "/"));
  const stDate = new Date(startDate?.replace(/-/g, "/"));
  const subtractInTicks =
    Date.UTC(
      // currentYear.getFullYear(),
      // currentYear.getMonth(),
      // currentYear.getDate()
      stDate.getFullYear(),
      stDate.getMonth(),
      stDate.getDate()
    ) -
    Date.UTC(
      dateOfBirth.getFullYear(),
      dateOfBirth.getMonth(),
      dateOfBirth.getDate()
    );
  const days = Math.floor(subtractInTicks / (1000 * 3600 * 24));
  const months = days / (365.25 / 12);
  return round(months);
}
/*' refactored by Junais on 14-Dec-2022 ' */
/*
export function getQuotationStageLabel(stage) {
  const stageClassNames = {
    Open: "badge bg-info",
    "Under Process": "badge bg-primary",
    Confirmed: "badge bg-success",
    Revision: "badge bg-warning",
    Abstained: "badge bg-secondary",
    "Business Lost ": "badge bg-danger",
    Expired: "badge bg-light text-dark",
  };
  return stageClassNames[stage] || "";
}*/
export function getMafStatusLabel(status) {
  const statusClassNames = {
    Complete: "badge bg-success",
    Incomplete: "badge bg-danger",
  };
  return statusClassNames[status] || "";
}
export function getMafReferralLabel(referralStatus) {
  const referralStatusClassNames = {
    Referral: "badge bg-primary",
    Clean: "badge bg-success",
    Incomplete: "badge bg-danger",
  };
  return referralStatusClassNames[referralStatus] || "";
}
export function getBatchStatusLabel(batchStatus) {
  const batchStatusLabel = {
    Processing: "badge bg-primary",
    Error: "badge bg-danger",
    Queued: "badge bg-warning",
    Complete: "badge bg-success",
    Pending: "badge bg-info"
  };
  return batchStatusLabel[batchStatus] || "";
}
function evenRound(num, decimalPlaces) {
  var d = decimalPlaces || 0;
  var m = Math.pow(10, d);
  var n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
  var i = Math.floor(n),
    f = n - i;
  var e = 1e-8; // Allow for rounding errors in f
  var r = f > 0.5 - e && f < 0.5 + e ? (i % 2 == 0 ? i : i + 1) : Math.round(n);
  return d ? r / m : r;
}
export function round(number) {
  return evenRound(number, 2);
}
export function getCurrentDate() {
  var currentDate = new Date().toISOString().substr(0, 10);
  // console.log("Date.now() ", Date.now(),date2234 );
  // var obj = new Date();
  // var day=obj.getDate();
  // var month=obj.getMonth() + 1;
  // var year=obj.getFullYear();
  // var currentDate =  year+ "-" + month+ "-" + day;
  return currentDate;
}
export function getMinusOneYearToCurrentDate() {
  //var currentDate = new Date().toISOString().substr(0, 10);
  var obj = new Date();
  // var day=obj.getDate();
  // var month=obj.getMonth() + 1;
  obj.setFullYear(obj.getFullYear() - 1);
  // var currentDate =  year+ "-" + month+ "-" + day;
  return obj.toISOString().substr(0, 10);;
}
export function getPlusOneMonthToCurrentDate() {
  //var currentDate = new Date().toISOString().substr(0, 10);
  var obj = new Date();
  // var day=obj.getDate();
  // var month=obj.getMonth() + 1;
  obj.setMonth(obj.getMonth() + 1);
  // var currentDate =  year+ "-" + month+ "-" + day;
  return obj.toISOString().substr(0, 10);;
}
export function getCurrentYear() {
  var currentYear = new Date().getFullYear();
  return currentYear;
}
export function getCurrentMonth() {
  var currentMonth = new Date().getMonth();
  return currentMonth;
}
export function getYearMasters() {
  var currentYear = new Date().getFullYear();
  var earliestYear = 1970;
  var yearMasters = [];
  while (currentYear >= earliestYear) {
    yearMasters.push({
      domainValue: currentYear,
      domainValueName: currentYear,
    });
    currentYear -= 1;
  }
  return yearMasters;
}
export function getSystemName(systemId, systems) {
  switch (systemId) {
    case appConstants.SYSTEM_ID_MEDICAL_CORE_ID:
      return appConstants.SYSTEM_ID_MEDICAL_CORE_TEXT;
    case appConstants.SYSTEM_ID_SECURITY:
      return appConstants.SYSTEM_ID_MEDICAL_SECURITY_TEXT;
    default:
      return "";
  }
}

export function getDefaultYearFirstDate() {
  const now = new Date(); // create a new date object for the current time
  const defaultYear = now.getFullYear(); // get the current year
  const firstDate = new Date(defaultYear, 0, 1); // create a new date object for January 1st of the current year
  return firstDate;
}

export function getDateByMonth(targetMonth) {
  alert(targetMonth)
  const currentYear = new Date().getFullYear(); // Get the current year
  const firstDate = new Date(currentYear, targetMonth - 1, 1); // Create a date for the specified month of the current year

  // Convert month index to abbreviated month name
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const abbreviatedMonth = monthNames[targetMonth - 1];

  // Construct the formatted date string (e.g., "Jul 1, 2023")
  const formattedDate = `${abbreviatedMonth} ${firstDate.getDate()}, ${currentYear}`;
  alert(formattedDate)
  return formattedDate; // Return the formatted date

}

export function getAsOfNowDate() {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
export function openUrl(url, params) {
  if (params) {
    let paramStr = "";
    Object.keys(params).forEach((key) => {
      if (paramStr != "") paramStr += "&";
      let value = params[key];
      if (value == null) value = "";
      paramStr += key + "=" + escape(value);
    });
    if (url.indexOf("?")) url += "?";
    url += paramStr;
  }
  window.open(url);
}

export function convertToCsharpDateTime(date) {
  var date = new Date(date);
  var day = date.getDate(); // yields date
  var month = date.getMonth() + 1; // yields month (add one as '.getMonth()' is zero indexed)
  var year = date.getFullYear(); // yields year
  var hour = date.getHours(); // yields hours
  var minute = date.getMinutes(); // yields minutes
  var second = date.getSeconds(); // yields seconds

  // After this construct a string with the above results as below
  var time =
    day + "/" + month + "/" + year + " " + hour + ":" + minute + ":" + second;
  return time;
}
// export function closeModal(modalId){
//    // $('#'+modalId).modal('hide');
//    alert($('#'+modalId).modal);
// }

export function getWorkFlowStatusBadge(workflowStatus) {
  const workflowStatusBadge = {
    324: "badge bg-success",
    325: "badge bg-success",
    326: "badge bg-danger",
    327: "badge bg-danger",
  };
  return workflowStatusBadge[workflowStatus] || "badge bg-warning";
}
// Junais
export function addCommasToValue(value) {

  // Convert value to string
  value = value.toString();

  // Split the value into integer and decimal parts (if any)
  const parts = value.split(".");
  let integerPart = parts[0];
  const decimalPart = parts[1] || "";

  // Add commas to the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Join the integer and decimal parts (if any)
  const formattedValue =
    decimalPart.length > 0 ? integerPart + "." + decimalPart : integerPart;

  return formattedValue;
}
export function isDate(value) {
  const dateRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
  return dateRegex.test(value);
}

export function getStatusBadge(fieldValue) {
  switch (fieldValue) {
    case "Open":
      return "badge bg-primary";
    case "Closed":
      return "badge bg-secondary text-light";
    case "Approved":
      return "badge bg-success";
    case "Not Approved":
      return "badge bg-danger";
    case "Under Process":
      return "badge bg-warning";
    case "Under Progress":
      return "badge bg-warning";
    case "Pending":
      return "badge bg-danger";
    case "Completed":
      return "badge bg-light text-dark";
    case "Abstained":
      return "badge bg-dark text-light";
    case "Expired":
      return "badge bg-danger";
    case "Confirmed":
      return "badge bg-success";
    default:
      return "";
  }
}

// Junais
export function trimText(text, maxLength) {
  if (text.length <= maxLength) {
    return text; // No trimming needed
  }
  // Trim the text and append "..." at the end
  const trimmedText = text.slice(0, maxLength - 3) + "...";
  return trimmedText;
}

// Junais 11-07-2023

export function formatAmount(decimalValue) {
  if (decimalValue === null) {
    return "NILL";
  }
  const amount = Number(decimalValue).toFixed(2);
  const parts = amount.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return parts.join('.');
}

export function getDashboardType(typeId) {
  switch (typeId) {
    case 1:
      return 'Pie Chart';
    case 2:
      return 'Bar Chart';
    case 3:
      return 'Line Chart';
    case 4:
      return 'Card';
    case 5:
      return 'Doughnut Chart';
    case 6:
      return 'Table';
    case 7:
      return 'List';
    default:
      return 'Unknown Type';
  }
}

export function CheckSpecialCharASCII(input) {
  // Loop through each character in the input string
  if (input == null) {
    return false;
  }
  for (let i = 0; i < input.length; ++i) {
    let ch = input.charCodeAt(i);
    // console.log(ch);
    if (!(ch >= 65 && ch <= 90) /* A-Z */ &&
      !(ch >= 97 && ch <= 122) /* a-z */ &&
      !(ch == 32) /* space */) {
      return true;
    }
  }
  // If no special characters were found
  return false;
}

export function getShafafiyaBatchStatusLabel(batchStatus) {
  const batchStatusLabel = {
    Renewed: "badge bg-warning",
    Cancelled: "badge bg-danger",
    New: "badge bg-primary",
  };
  return batchStatusLabel[batchStatus] || "";
}


export function getICPMemberLinkedLabel(memberLinked) {
  const memberLinkedLabel = {
    L: "badge bg-success",
    R: "badge bg-danger"
  };
  return memberLinkedLabel[memberLinked] || "";
}

export function getICPMemberStatusLabel(memberStatus) {
  const memberStatusLabel = {
    CR: "badge bg-success",
    CA: "badge bg-danger"
  };
  return memberStatusLabel[memberStatus] || "";
}


export function calculateAgeString(dob) {

  var todate = new Date();

  var age = [], dob = new Date(dob),
    y = [todate.getFullYear(), dob.getFullYear()],
    ydiff = y[0] - y[1],
    m = [todate.getMonth(), dob.getMonth()],
    mdiff = m[0] - m[1],
    d = [todate.getDate(), dob.getDate()],
    ddiff = d[0] - d[1];

  if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff;
  if (mdiff < 0) mdiff += 12;
  if (ddiff < 0) {
    dob.setMonth(m[1] + 1, 0);
    ddiff = dob.getDate() - d[1] + d[0];
    --mdiff;
  }
  if (ydiff >= 0) age.push(ydiff + ' year' + (ydiff != 1 ? 's, ' : ', '));
  if (mdiff >= 0) age.push(mdiff + ' month' + (mdiff != 1 ? 's, ' : ', '));
  if (ddiff >= 0) age.push(ddiff + ' day' + (ddiff != 1 ? 's' : ''));
  if (age.length > 1) age.splice(age.length - 1, 0);
  return age.join('');
}

// export function calculateAgeByEffectiveDate(dob, startDate) {
//   var dob = new Date(dob), startDate = new Date(startDate),
//     res,
//     y = [startDate.getFullYear(), dob.getFullYear()],
//     ydiff = y[0] - y[1],
//     m = [startDate.getMonth(), dob.getMonth()],
//     mdiff = m[0] - m[1],
//     d = [startDate.getDate(), dob.getDate()],
//     ddiff = d[0] - d[1];
//   if (dob > startDate) {
//     return null;
//   }
//   if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff;
//   if (mdiff < 0) mdiff += 12;
//   if (ddiff < 0) {
//     dob.setMonth(m[1] + 1, 0);
//     ddiff = dob.getDate() - d[1] + d[0];
//     --mdiff;
//   }

//   if (mdiff >= 6) ydiff += 1; //if 6 months or above, year increased by 1
//   if (ydiff >= 0) {
//     res = (ydiff/*  + ' year' + (ydiff != 1 ? 's' : '') */);
//   }
//   else {
//     res = null;
//   }
//   return res;
// }

// export function calculateAgeByEffectiveDateV3(dob, startDate) {

//   var todate = new Date(startDate);

//   var age = [], 
//   dob = new Date(dob), 
//   y = [todate.getFullYear(), dob.getFullYear()], 
//   ydiff = y[0] - y[1], 
//   m = [todate.getMonth(), dob.getMonth()], 
//   mdiff = m[0] - m[1], 
//   d = [todate.getDate(), dob.getDate()], 
//   ddiff = d[0] - d[1];

//   if (dob > startDate) {
//     return null;
//   }

//   if (mdiff < 0 || (mdiff === 0 && ddiff < 0)) --ydiff;
//   if (mdiff < 0) mdiff += 12;
//   if (ddiff < 0) { dob.setMonth(m[1] + 1, 0);
//     ddiff = dob.getDate() - d[1] + d[0];
//     --mdiff;
//   }
//   if (ydiff >= 0) age.push(ydiff + ' year' + (ydiff != 1 ? 's, ' : ', '));
//   if (mdiff >= 0) age.push(mdiff + ' month' + (mdiff != 1 ? 's, ' : ', '));
//   else {
//       age.push(11 + ' month' + (11 != 1 ? 's, ' : ', '));
//       mdiff = 11;
//       ddiff +=1;
//   }
//   if (ddiff >= 0) age.push(ddiff + ' day' + (ddiff != 1 ? 's' : ''));
//   if (age.length > 1) age.splice(age.length - 1, 0);


//   console.log(age.join(''))
//   console.log("--------------------");
//   console.log("actualAge: ", ydiff)

//   if(mdiff >= 6) {
//     ydiff+=1;
//   }

//   console.log("medSysAge: ", ydiff)


//   return ydiff;
// }


export function calculateAgeByEffectiveDateV2(d1, d2) {
  // Convert dates to Date objects if they are not already
  const date1 = new Date(d1);
  const date2 = new Date(d2);

  // Ensure date1 is the earlier date
  // if (date1 > date2) {
  //   [date1, date2] = [date2, date1];
  // }
  // if (date1 > date2) {
  //   return null;
  // }

  let years = date2.getFullYear() - date1.getFullYear();
  let months = date2.getMonth() - date1.getMonth();
  let days = date2.getDate() - date1.getDate();

  // Adjust days and months if days are negative
  if (days < 0) {
    months--;
    // Adjust days to the previous month
    const previousMonth = new Date(date2.getFullYear(), date2.getMonth(), 0);
    days += previousMonth.getDate();
  }

  // Adjust months if months are negative
  if (months < 0) {
    years--;
    months += 12;
  }
  if (months >= 6) {
    years++;
  }
  return years;
}
